import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { AddOnCustomize } from "./component";
import {
  isCfarAvailableSelector,
  isDisruptionProtectionAvailableSelector,
  selectedCfarIdSelector,
  selectedDisruptionProtectionIdSelector,
  selectedCfarOfferPricesSelector,
  selectedDisruptionProtectionOfferPricesSelector,
  fetchAncillaryOfferCallStateSelector,
  cfarAddOnChoicePropertiesSelector,
  isOptionSelectionCompleteSelector,
  isCfarOptionSelectionCompleteSelector,
  isDpOptionSelectionCompleteSelector,
  dpAddOnChoicePropertiesSelector,
  dpOfferPropertiesForViewBookingAddOnSelector,
  cfarAttachPropertiesForViewBookingAddOnSelector,
  viewBookingAddOnPropertiesSelector,
  hasActiveRefundableFareInFlightShopSelector,
  selectedDiscountedCfarOfferPricesSelector,
  cfarOfferSelector,
  cfarDiscountPropertiesSelector,
  selectedCfarOfferCoverageSelector,
  selectedFareDetailsSelector,
  disruptionProtectionOfferSelector,
  selectedDisruptionProtectionOfferProductVariantSelector,
} from "../../../reducer/selectors";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../rewards/reducer/selectors";
import {
  populateFlightBookQueryParams,
  scheduleQuote,
} from "../../../../book/actions/actions";
import {
  getDpOptionSelectionProgressSelector,
  getCfarOptionSelectionProgressSelector,
  getCheckoutStepNumberSelector,
  hasTravelFusionInSelectedTripDetailsSelector,
} from "../../../../book/reducer";
import {
  fetchAncillaryOffer,
  setSelectedCfarId,
  setSelectedDisruptionProtectionId,
  setSelectedHtsCfarOfferId,
  setSelectedHtsDisruptionOfferId,
} from "../../../actions/actions";
import { IStoreState } from "../../../../../reducers/types";
import {
  cfarSocialVariantSelector,
  cfarDiscountPromoCopy,
  isCfarCoMerchEnabledSelector,
  isAirOfferRedesignEnabledSelector,
} from "../../../../ancillary/reducer";

const mapStateToProps = (state: IStoreState) => ({
  isCfarAvailable: isCfarAvailableSelector(state),
  isDisruptionProtectionAvailable:
    isDisruptionProtectionAvailableSelector(state),
  selectedCfarId: selectedCfarIdSelector(state),
  selectedDisruptionProtectionId: selectedDisruptionProtectionIdSelector(state),
  cfarOfferPrices: selectedCfarOfferPricesSelector(state),
  disruptionProtectionOfferPrices:
    selectedDisruptionProtectionOfferPricesSelector(state),
  rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  fetchAncillaryOfferCallState: fetchAncillaryOfferCallStateSelector(state),
  cfarAddOnChoiceProperties: cfarAddOnChoicePropertiesSelector(state),
  dpAddOnChoiceProperties: dpAddOnChoicePropertiesSelector(state),
  isOptionSelectionComplete: isOptionSelectionCompleteSelector(state),
  isCfarOptionSelectionComplete: isCfarOptionSelectionCompleteSelector(state),
  isDpOptionSelectionComplete: isDpOptionSelectionCompleteSelector(state),
  viewBookingAddOnProperties: viewBookingAddOnPropertiesSelector(state),
  dpOfferPropertiesForViewBookingAddOn:
    dpOfferPropertiesForViewBookingAddOnSelector(state),
  cfarOfferPropertiesForViewBookingAddOn:
    cfarAttachPropertiesForViewBookingAddOnSelector(state),
  getDpOptionSelectionProgress: getDpOptionSelectionProgressSelector(state),
  getCfarOptionSelectionProgress: getCfarOptionSelectionProgressSelector(state),
  getCheckoutStepNumber: getCheckoutStepNumberSelector(state),
  hasActiveRefundableFare: hasActiveRefundableFareInFlightShopSelector(state),
  cfarSocialVariant: cfarSocialVariantSelector(state),
  cfarDiscountPromoCopy: cfarDiscountPromoCopy(state),
  discountedCfarOffer: selectedDiscountedCfarOfferPricesSelector(state),
  cfarOffer: cfarOfferSelector(state),
  cfarDiscountProperties: cfarDiscountPropertiesSelector(state),
  isAirOfferRedesignEnabled: isAirOfferRedesignEnabledSelector(state),
  isCfarCoMerchEnabled: isCfarCoMerchEnabledSelector(state),
  selectedCfarOfferCoverage: selectedCfarOfferCoverageSelector(state),
  selectedFare: selectedFareDetailsSelector(state),
  hasTravelFusionFareBrand: hasTravelFusionInSelectedTripDetailsSelector(state),
  disruptionOffer: disruptionProtectionOfferSelector(state),
  fdaProductVariant:
    selectedDisruptionProtectionOfferProductVariantSelector(state),
});

const mapDispatchToProps = {
  populateFlightBookQueryParams,
  fetchAncillaryOffer,
  scheduleQuote,
  setSelectedCfarId,
  setSelectedDisruptionProtectionId,
  setSelectedHtsCfarOfferId,
  setSelectedHtsDisruptionOfferId,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AddOnCustomizeConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedAddOnCustomize = withRouter(connector(AddOnCustomize));
